export const formatScheduledLabel = (
  scheduledAt: string | null | undefined,
  variant: "scheduled" | "published" = "scheduled"
): string => {
  const prefix = variant === "published" ? "Published" : "Scheduled";
  return scheduledAt ? `${prefix} ${new Date(scheduledAt).toLocaleString()}` : prefix;
};
